import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  app = environment.app;
  storageUrl = environment.storageUrl;
  socketUrl = environment.socketUrl;
  appLogo = environment.appLogo;
  constructor() {}
}
